
const modalMethods = {

    watch:{
      
        async 'form_data.building_id'(val)
        {
            if(val)
            {
                let object = {
                    id:             val,
                    radio_request:  false,
                    level_request:  true,
                    area_request:   false,
                    room_request:   false,
                    value:          '',
                }
                let response = await this.get(`${this.rest_api}/${JSON.stringify(object)}`)
                if(response.status)
                {
                    if(response.data.levels.length)
                    {
                        this.array_options.level_id = response.data.levels
                        this.form_data.level_id     = this.array_options.level_id[0].id
                    }
                    else
                    {
                        this.array_options.level_id = []
                        this.form_data.level_id     = ''
                    }
                }
                else
                {
                    this.error_handling(response)
                }
            }else{
                this.array_options.level_id = []
                this.array_options.area_id  = []
                this.form_data.level_id     = ''
                this.form_data.area_id      = ''
                this.rooms                  = []
            }
        },

        async 'form_data.level_id'(val)
        {
            if(val){
                let object = {
                    id:             val,
                    radio_request:  false,
                    level_request:  false,
                    area_request:   true,
                    room_request:   false,
                    value:          '',
                }
              
                let response = await this.get(`${this.rest_api}/${JSON.stringify(object)}`)
                if(response.status){
                    if(response.data.areas.length){
                        this.array_options.area_id = response.data.areas
                        this.form_data.area_id     = this.array_options.area_id[0].id
                    }else{
                        this.array_options.area_id = []
                        this.form_data.area_id     = ''
                    }
                }else{
                    this.error_handling(response)
                }
            }else{
                this.array_options.area_id  =  []
                this.form_data.area_id      =  ''
                this.rooms                  =  []
            }
        },

        task_id(val)
        {
            this.$emit('dinamicTask', val)
        },

    },

    methods:{

        async start_search()
        {
            if(!this.form_data.area_id)
            {
                this.notyf.error('No area selected')
                return false
            }

            if(this.task_id === '')
            {
                this.notyf.error('No task selected')
                return false
            }

            let object = {
                id:             this.form_data.area_id,
                radio_request:  false,
                level_request:  false,
                area_request:   false,
                room_request:   true,
                value:          this.task_id,
            }
            let response = await this.get(`${this.rest_api}/${JSON.stringify(object)}`)

            if(response.status)
            {
                if(response.data.rooms.length)
                {
                    this.rooms = response.data.rooms
                    this.rooms.forEach((item) => {
                        item['checked'] = false
                    })
                }
                else
                {
                    this.rooms = []
                    this.notyf.error('No rooms available')
                }
            }
            else
            {
                this.error_handling(response)
            }
        },

        form_submit()
        {
            if(!this.table_selection.length)
            {
                this.notyf.error(`Select a room`)
                return false
            }
            setTimeout( () => { window.$('#static').modal('hide') }, 500 )
            this.$emit('arrayPush', this.table_selection)
            this.notyf.success(`Success`)
        },

    },

    mounted(){

    }

}

export default modalMethods